import React from 'react'
import styled, { css } from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'

interface Props {
  selectedValue?: string
  onChange: (newValue: string | boolean) => void
  className?: string
  options: RadioOption[]
}

export type RadioOption = {
  value: string | boolean
  label: string
}

export const Radio: React.FC<Props> = ({
  selectedValue,
  onChange,
  className,
  options = [],
  ...rest
}) => {
  return (
    <Wrapper className={className}>
      {options.map((item, index) => {
        return (
          <RadioItem
            key={index}
            onClick={() => {
              onChange(item.value)
            }}
            isActive={selectedValue === item.value}
            {...rest}
          >
            {item.label}
          </RadioItem>
        )
      })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
`

interface RadioItemProps {
  isActive?: boolean
}

const RadioItem = styled.div<RadioItemProps>`
  position: relative;
  overflow: hidden;
  display: block;
  padding-left: 30px;
  cursor: pointer;
  color: ${themeEstra.color.primari.grigioEstra};

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    border-radius: 50%;
    width: 20px;
    height: 20px;
  }

  &:before {
    background-color: ${({ theme }) => theme.color.neutri.grigioBg};
    border: 1px solid ${({ theme }) => theme.color.neutri.grigioChiaro};
  }

  &:after {
    ${({ isActive }) =>
      isActive
        ? css`
            background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
            background-size: 10px;
            background-position: center;
            background-repeat: no-repeat;
            background-color: ${({ theme }) => theme.color.primari.verde};
          `
        : null};
  }

  + * {
    margin-left: 1.5rem;
  }
`
